var map = {
	"./jWewNKg9ZL.png": 106,
	"./logo-footer.gif": 107,
	"./logo-footer1.png": 108,
	"./logo.png": 109,
	"./logo2.png": 110,
	"./pp.jpg": 26,
	"./slide.gif": 111,
	"./slide.png": 112,
	"./teacher.png": 113,
	"./teacher1.png": 114,
	"./video-1.png": 115,
	"./video-2.png": 116,
	"./video-3.png": 117
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30;